import { Badge } from '@mui/material'
import React, { useContext } from 'react'

import { FeatureFlags } from '../../models/FeatureFlags'
import { AppContext } from '../../providers/AppProvider/AppProvider'

export const TimeClockBadgeWrapper = ({
  children
}: {
  children: React.ReactNode
}) => {
  const { openTimeClockWithRelated, featureFlags } = useContext(AppContext)
  if (featureFlags && featureFlags[FeatureFlags.TimeClock]) {
    return (
      <Badge
        color={openTimeClockWithRelated ? 'success' : 'warning'}
        overlap="circular"
        badgeContent=" "
        variant="dot">
        {children}
      </Badge>
    )
  }
  return <> {children}</>
}
